import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-establishment-card',
  templateUrl: './establishment-card.component.html',
  styleUrls: ['./establishment-card.component.scss'],
})
export class EstablishmentCardComponent implements OnInit {
  @Input() options: any;
  @Input() additionalClasses: any;
  @Input() otherAdditionalClasses: any;
  @Input() organizationsLogo: string;
  @Input() organizationsPositions: any;
  @Input() organizationsCompany_name: string;
  @Input() organizationsAddress: string;
  @Input() organizationsPostal_code: string;
  @Input() organizationsCity: string;
  @Input() organizationsPhone_number: any;
  @Input() organizationsEmail: string;
  @Input() organizationsWebsite_url: string;
  @Input() organizationsPronote_link: string;
  constructor() {}

  ngOnInit(): void {}
}
